import { IAccount } from "../../models/IAccount";
import { IAccountData } from "../../models/IAccountData";
import { IAccountTradeLimit } from "../../models/IAccountTradeLimit";

export class AdminAccountState {
  accounts: IAccount[] = [];
  accountData: IAccountData[] = [];
  accountTradeLimits: IAccountTradeLimit[] = [];
}
